import { render, staticRenderFns } from "./DoorRecycling.vue?vue&type=template&id=ea3a46fe&scoped=true"
import script from "./DoorRecycling.vue?vue&type=script&lang=js"
export * from "./DoorRecycling.vue?vue&type=script&lang=js"
import style0 from "./DoorRecycling.vue?vue&type=style&index=0&id=ea3a46fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3a46fe",
  null
  
)

export default component.exports